<template>
  <div :class="[$style.errorBox, { [$style.mobile]: isMobile }]">
    <div :class="$style.fullWrap" v-if="errorCode == ErrorCodeMap.COMMPANY_PACKAGE_EXPIRED">
      <div :class="$style.fullErrorIcon">
        <img src="./assets/warningTips.svg" :class="$style.img" />
      </div>
      <div :class="$style.fullMsg">
        {{ msg }}
      </div>
      <div :class="$style.btns">
        <div>
          <button :class="[$style.btnItem, $style.buyBtn]" class="kButton" @click="clickHandle('goBuy')">
            {{ buyText }}
          </button>
        </div>
        <button :class="[$style.btnItem, $style.secondBtnStyle]" @click="clickHandle('download')">
          {{ $t("d8ffb18522") }}
        </button>
      </div>
    </div>
    <div :class="[$style.wrap, { [$style.typeIcon]: errorType }]" v-else>
      <img v-if="isWaitCheck" :src="require('./assets/check.png')" :class="$style.img" />
      <img v-else-if="errorType && fileType" :src="require(`./assets/media.svg`)" :class="[$style.img, $style.media]" />
      <img v-else :src="require('./assets/error.png')" :class="$style.img" />
      <div :class="[$style.name, { [$style.checkName]: isWaitCheck }]" v-if="title && isLogin">
        {{ title }}
      </div>
      <div :class="$style.msg" v-if="msg">
        <!-- 最早没有考虑过错误主标题和简介的设定，这里只针对分享连接做简单处理，后面如果有更多同类错误接入再改 -->
        <template v-if="errorCode === 'lightLinkNotExist'">
          {{ msg }}
        </template>

        <template v-else-if="errorCode === 'linkClosed'">
          <div style="margin: 20px 0 8px">
            {{ $t("2314ce6081")
            }}<img :src="errorInfo.creator.avatar" :class="$style.userAvatar" />{{ errorInfo.creator.nickname }}
          </div>
          {{ $t("241c63f81a") }}
        </template>

        <template v-else-if="errorCode === 'notCompanyMember'">
          <div style="margin: 20px 0 8px">
            {{ $t("b573db113b")
            }}<img :src="errorInfo.creator.avatar" :class="$style.userAvatar" />{{ errorInfo.creator.nickname }}
          </div>
          {{ $t("241c63f81a") }}
        </template>

        <template v-else-if="errorCode == ErrorCodeMap.NOT_COMPANY_USER_1_STR ||
          errorCode == ErrorCodeMap.NOT_COMPANY_USER_2_STR
          ">
          {{ msg }}
          <p>{{ userInfo && $t("12069886e3", [userInfo.nickname]) }}</p>
        </template>

        <template v-else-if="errorCode === 'lightlinkForbid' && appealStatus">{{
          $t("ced44fd785")
        }}</template>

        <template v-else>
          <div v-html="msg"></div>
          <!-- <span @click="changeAccount" v-if="userInfo && !fileInfo"> 更换账号</span> -->
        </template>
      </div>
      <div :class="$style.btns">
        <div v-if="showCertify && $modules.certify">
          <button :class="$style.download" class="kButton" @click="clickHandle('authentication')">
            {{ $t("65680083e0") }}
          </button>
        </div>
        <div v-if="showBuyBtn && $modules.canBuy">
          <button :class="$style.download" class="kButton" @click="clickHandle('goBuy')">
            {{ buyText }}
          </button>
        </div>
        <button :class="$style.download" class="kButton" v-if="errorCode === 'lightlinkForbid' &&
          !appealStatus &&
          $modules.applyRecovery
          " @click="clickHandle('appeal')">
          {{ $t("a8c1a910b2") }}
        </button>
        <template v-else-if="isLogin && showDownload && $modules.download">
          <button :class="[
            $style.download,
            showCertify || showBuyBtn ? $style.secondBtnStyle : 'kButton',
          ]" @click="clickHandle('download')" v-if="isAllowDownload">
            {{ $t("d8ffb18522") }}
          </button>
        </template>
        <button :class="$style.download" class="kButton" v-else-if="!userInfo && $modules.login"
          @click="clickHandle('login')">
          {{ $t("6e4e2132b7") }}
        </button>
        <button :class="$style.download" class="kButton" v-else-if="$modules.toHome" @click="clickHandle('goHome')">
          {{ $t("71737deac3") }}
        </button>
      </div>
      <div :class="$style.tips" v-if="isWaitCheck">
        <span :class="$style.help" @click="clickHandle('contactUs')">{{
          $t("11373c971b")
        }}</span>
      </div>
      <div :class="$style.buyTips" v-if="msg && errorCode == ErrorCodeMap.COMMPANY_PACKAGE_FAILED && !isMember
          ">
        <img src="./assets/info.svg" alt="" />{{ $t("1b310928e3") }}
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n'
import { mapState } from 'vuex'
import { logout, download, downloadBySid, appeal } from '@/services/api'
import getError, { errorMap } from '@/utils/error.js'
import { errorCodeMap } from '@/utils/errorcodes.js'
import DownloadCommand from '@/utils/command/download'
import { utmSource } from '@/utils/utm'
export default {
  name: 'ErrorPage',
  props: {
    msg: {
      type: String,
      default: ''
    },
    errorCode: {
      type: [String, Number],
      default: ''
    },
    errorInfo: {
      type: [Object, null],
      default: null
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  async mounted() {
    if (this.userInfo && this.userInfo.is_company_account && this.fileInfo) {
      const res = await this.getDownUrl()
      if (res.downloadUrl) {
        this.downloadUrl = res.downloadUrl
        this.isAllowDownload = true
      } else {
        this.downloadUrl = ''
        this.isAllowDownload = false
      }
    } else {
      this.isAllowDownload = true
    }
  },
  data() {
    return {
      appealStatus: false,
      isAllowDownload: false,
      downloadUrl: '',
      downloadError: {}
    }
  },
  computed: {
    ...mapState(['fileType', 'fileInfo', 'userInfo', 'userSelf']),
    ErrorCodeMap() {
      return errorCodeMap
    },
    errorType() {
      if (errorMap[this.errorCode]) {
        return false
      }
      return true
    },
    isWaitCheck() {
      return [errorCodeMap.WAIT_M_CHECK, errorCodeMap.WAIT_P_CHECK].includes(
        this.errorCode
      )
    },
    showCertify() {
      return (
        !this.isMobile &&
        this.errorCode === errorCodeMap.COMPANY_NOT_CERTIFY &&
        this.userSelf.roles !== 'member'
      )
    },
    showBuyBtn() {
      return (
        !this.isMobile &&
        this.errorCode === errorCodeMap.COMMPANY_PACKAGE_FAILED
      )
    },
    showDownload() {
      let exclude = [
        errorCodeMap.WAIT_M_CHECK,
        errorCodeMap.WAIT_P_CHECK,
        errorCodeMap.AUTH_CHECK_FAILED,
        errorCodeMap.FILENAME_CHECK_FAILED,
        errorCodeMap.FILENAME_CHECK_FAILED_STR,
        errorCodeMap.NOT_LOGIN_STR,
        'linkClosed',
        'notCompanyMember',
        'lightlinkForbid',
        'lightLinkNotExist',
        'fileNotExists',
        'permissionDenied',
        errorCodeMap.NOT_COMPANY_USER__2_STR,
        errorCodeMap.NOT_COMPANY_USER_1_STR
      ]
      if (
        !exclude.includes(this.errorCode) &&
        ((this.userInfo && this.fileInfo) || this.$route.params.sid)
      ) {
        return true
      }
      return false
    },
    isLogin() {
      return ![errorCodeMap.NOT_LOGIN, errorCodeMap.NOT_LOGIN_STR].includes(
        this.errorCode
      )
    },
    title() {
      let title = i18n.t('dbc00698ae')
      if (this.fileInfo) {
        title = this.fileInfo.fname.split('.').slice(0, -1).join('.')
      }

      // 如果能够从错误map中找到，则用map中的数据
      let _errorTitle = getError(this.errorCode)
      if (_errorTitle) {
        if (!this.fileInfo) {
          title = ''
        }
      }
      if (
        [errorCodeMap.WAIT_M_CHECK, errorCodeMap.WAIT_P_CHECK].includes(
          this.errorCode
        )
      ) {
        title = i18n.t('d4c9ed35b7')
      }
      if (
        this.errorCode === errorCodeMap.FILENAME_CHECK_FAILED ||
        this.errorCode === errorCodeMap.FILENAME_CHECK_FAILED_STR ||
        this.errorCode === errorCodeMap.AUTH_CHECK_FAILED
      ) {
        title = i18n.t('0c01094048')
      }
      // 处理其他情况
      if (
        this.errorCode === 'permissionDenied' ||
        this.errorCode === errorCodeMap.NOT_COMPANY_USER_1_STR ||
        this.errorCode === errorCodeMap.NOT_COMPANY_USER_2_STR
      ) {
        title = i18n.t('dbc00698ae')
      }
      if (this.errorCode === 'fileNotExists') {
        title = i18n.t('8af9862a91')
      }
      if (this.errorCode === 'lightLinkNotExist') {
        title = i18n.t('4d74f721f5')
      }
      if (this.errorCode === 'lightlinkForbid') {
        title = i18n.t('1a9e17476b')
      }
      if (this.appealStatus) {
        title = i18n.t('6667a5fc14')
      }
      return title
    },
    isMember() {
      return this.userSelf.roles === 'member'
    },
    buyText() {
      return this.isMember ? i18n.t('5007152f7d') : i18n.t('7ae4470de8')
    }
  },
  watch: {
    errorCode: {
      immediate: true,
      handler: function (val) {
        if (
          [
            errorCodeMap.NOT_LOGIN,
            errorCodeMap.FILENAME_CHECK_FAILED,
            errorCodeMap.FILENAME_CHECK_FAILED_STR,
            errorCodeMap.AUTH_CHECK_FAILED,
            errorCodeMap.NOT_LOGIN_STR
          ].includes(val)
        ) {
          document.title = i18n.t('fdb37ade7f')
          this.$store.commit('SET_DOCUMENT_TITLE', false)
        }
      }
    }
  },
  methods: {
    async getDownUrl() {
      let downloadAdapter = null
      if (this.userInfo) {
        downloadAdapter = download(this.fileInfo.groupid, this.fileInfo.fileid)
      } else if (this.$route.params.sid) {
        downloadAdapter = downloadBySid(this.$route.params.sid)
      } else {
        downloadAdapter = download(this.fileInfo.groupid, this.fileInfo.fileid)
      }
      try {
        const res = await downloadAdapter
        return {
          downloadUrl: res.fileinfo.url
        }
      } catch ({ response = {} }) {
        return {
          downloadUrl: '',
          error: response.data || {}
        }
      }
    },
    reportFn(operation) {
      this.$emit('dwReporter', {
        page: 'unpreview',
        operation,
        error_code: this.errorCode
      })
    },
    clickHandle(val) {
      if (['authentication', 'download', 'appeal'].includes(val)) {
        this.reportFn(val === 'download' ? 'download_tip' : val)
      }
      this[val]()
    },
    async goBuy() {
      const url = `https://plus.wps.cn/buy?utm_medium=media_play_duration&privilegeName=media_play_duration&utm_source=${utmSource}&situation_skip=1`
      if (this.isMember) {
        this.reportFn('click_applybuy')
        const loadEpSdk = () => new Promise(async (resolve, reject) => {
          if (window.epPlatform) return resolve(window.epPlatform)
          // 获取 入口文件的sri签名值
          const hash = await this.axios.get('https://plus.wps.cn/fab/sris/epplatform_sri.json')
          const s = document.createElement('script')
          s.src = 'https://plus.wps.cn/fab/sdk/v1/epplatform'
          if (hash) {
            s.integrity = hash.epplatform
            s.crossOrigin = 'anonymous'
          }
          s.onload = () => resolve(window.epPlatform); s.onerror = reject
          document.head.appendChild(s)
        })
        loadEpSdk().then(() => {
          epPlatform.showUpgradePrivilege({
            closed: true,
            companyid: this.userInfo.companyid,
            privilegeName: 'media_play_duration',
            utmSource: utmSource,
            utmMedium: 'media_play_duration',
            position: 'media_play_duration',
            content: (vm) => i18n.t('5a50e52115', [vm.secondService.spkg_desc])
          })
        })
      } else {
        this.reportFn('click_buy')
        window.open(url)
      }
    },
    login() {
      let loginUrl = `https://account.wps.cn/?cb=${encodeURIComponent(location.href)}`
      window.location.href = loginUrl
    },
    goHome() {
      window.location.href = 'https://docs.wps.cn'
    },
    authentication() {
      window.open('https://work.wps.cn/base/setting/information/certification')
    },
    retry() {
      window.location.reload()
    },
    contactUs() {
      this.$emit('contactUs')
    },
    changeAccount() {
      logout()
        .then((_) => {
          this.login()
        })
        .catch((_) => { })
    },
    async download() {
      if (!this.fileInfo) return
      // 判断没有下载地址时，处于个人账号重新获取下载地址
      if (this.downloadUrl === '') {
        const res = await this.getDownUrl()
        this.downloadUrl = res.downloadUrl
        this.downloadError = res.error
      }
      if (this.downloadUrl) {
        const command = new DownloadCommand(this.downloadUrl, this.fileInfo, true)
        command.execute()
      } else {
        let { result, code } = this.downloadError
        this.getErrorMsg(result || code)
      }

    },
    getErrorMsg(e) {
      let msg = getError(e)
      if (msg) {
        this.msg = msg
        return this.$message.error(msg)
      }
      this.$message.error(i18n.t('dc8e5b3b97'))
    },
    async appeal() {
      let resp = await appeal(this.$route.params.sid).catch((err) => {
        if (
          err.detail.info &&
          err.detail.info.result === errorCodeMap.NOT_LOGIN_STR
        ) {
          this.login()
        }
      })
      if (resp) {
        this.appealStatus = true
      }
    }
  }
}
</script>
<style lang="scss" module>
.errorBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.fullWrap {
  margin: 0 150px;
  background: var(---gray-kd-color-gray-9, #333);
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .fullErrorIcon {
    margin-bottom: 16px;

    img {
      width: 100px;
      height: 100px;
    }
  }

  .fullMsg {
    color: var(---kd-color-text-white, #fff);
    font-size: 14px;
    line-height: 22px;
  }

  .btnItem {
    width: 238px;
    height: 34px;
    font-size: 14px !important;
    border-radius: 5px !important;
    margin-bottom: 4px;

    &.buyBtn {
      color: rgba(118, 64, 29, 1);
      background: var(---svp-card-btn-bg-normal, #fac67d);

      &:hover {
        background: var(---svp-card-btn-bg-hover, #fbd49c);
      }

      &:active {
        background: var(---svp-card-btn-bg-pressed, #dfa968);
      }
    }

    &.secondBtnStyle {
      color: var(---kd-color-text-white, #fff);
      background: rgba(245, 245, 245, 0);

      &:hover {
        background: rgba(245, 245, 245, 0.06);
      }

      &:active {
        background: rgba(245, 245, 245, 0.1);
      }
    }
  }
}

.wrap {
  background: #fff;
  padding: 30px 0 32px;
  width: 450px;
  text-align: center;
  position: relative;
  border-radius: 8px;
  border: 1px solid var(---kd-color-line-regular, rgba(13, 13, 13, 0.12));
  box-shadow: 0px 12px 32px 0px rgba(13, 13, 13, 0.08);
  overflow: hidden;
}

.img {
  display: block;
  width: 150px;
  height: 150px;
  user-select: none;
  margin: 0 auto;
}

.name {
  color: #3c414b;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  margin: 24px 30px 0;
  color: var(---kd-color-text-primary, rgba(13, 13, 13, 0.9));
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
}

.checkName {
  margin-top: 0;
  line-height: 18px;
}

.msg {
  font-size: 14px;
  margin: 16px auto 0;
  width: 300px;
  color: var(---kd-color-text-primary, rgba(13, 13, 13, 0.9));
  font-size: 14px;
  line-height: 22px;
}

.btns {
  margin-top: 32px;
}

.download {
  width: 238px;
  height: 34px;
  font-size: 14px !important;
  border-radius: 5px !important;
  margin-bottom: 4px;
}

.secondBtnStyle {
  width: 238px;
  height: 34px;
  background: #ffffff;
  border: none;
  cursor: pointer;

  &:hover {
    background: var(---kd-color-state-hover, rgba(13, 13, 13, 0.06));
  }

  &:active {
    background: var(---kd-color-state-pressed, rgba(13, 13, 13, 0.1));
  }
}

.tips {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;

  .help {
    color: #417ff9;
    font-size: 13px;
    user-select: none;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}

.buyTips {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: var(---kd-color-warning-light, #fef1ea);
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 24px;
  color: var(---orange-kd-color-orange-9, #7b3005);
  font-size: 12px;
}

.typeIcon {
  .name {
    margin: 16px 30px 0;
  }

  .img {
    width: 72px;
    height: 72px;
    margin: 40px auto 20px;

    &.media {
      width: 390px;
      height: 220px;
      margin: 0 auto 20px;
    }
  }

  .btns {
    margin-top: 24px;
  }
}

.mobile {
  .wrap {
    box-shadow: none;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 90px 0 0;
  }

  .name {
    font-size: 20px;
    line-height: 23px;
    color: #353535;
  }

  .msg {
    font-size: 16px;
    line-height: 23px;
    color: #979797;
    margin: 6px auto 0;
  }

  .download {
    font-size: 18px;
    height: 40px;
    margin: 0 6%;
    width: 88%;
  }

  .secondBtnStyle {
    margin: 10px 0;
  }
}

.userAvatar {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin: 0 5px;
}
</style>
